class NewsletterOptInFromContact {
  constructor({
    formSelector,
    emailSelector = 'input[type="email"][name^="contact["]',
    checkboxSelector = 'input[type="checkbox"][name="contact[Newsletter Opt-In]"]',
    endpoint = '//webapp-powdershopifybackend-prd.azurewebsites.net/api/customers/from-contact'
  }) {
    this.form = document.querySelector(formSelector);
    if (!this.form) return;

    console.log(`this.form`, this.form)

    this.emailSelector = emailSelector;
    this.checkboxSelector = checkboxSelector;
    this.endpoint = endpoint;

    this.hasSubmitted = false;
    this.bindEvents();

    const reason = this.getQueryParam('reasonForContacting');
    if (reason) {
      const select = this.form.querySelector('select[name="contact[reason-for-contacting]"]');
      if (select) {
        let found = false;
        for (const option of select.options) {
          if (option.value.trim().toLowerCase() === reason.trim().toLowerCase()) {
            option.selected = true;
            found = true;
            break;
          }
        }
      }
    }
  }

  getQueryParam(name) {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
  }

  bindEvents() {
    this.form.addEventListener('submit', (event) => this.onSubmit(event));
  }

  async onSubmit(event) {
    if (this.hasSubmitted) return;

    event.preventDefault();

    try {
      const subscribe = await this.subscribe();
      console.log(`subscribe`, subscribe)
      debugger;
    } catch (e) {
      // silent fail — do not block UX
    } finally {
      this.resumeSubmit();
    }
  }

  resumeSubmit() {
    this.hasSubmitted = true;

    if (typeof this.form.requestSubmit === 'function') {
      this.form.requestSubmit();
    } else {
      this.form.submit();
    }
  }

  // -------------------------
  // NEW: collect + payload
  // -------------------------

  collectFormValues() {
    const data = {};
    const elements = this.form.querySelectorAll('input[name], select[name], textarea[name]');

    for (const el of elements) {
      if (el.disabled) continue;

      const name = (el.name || '').trim();
      if (!name) continue;

      const tag = el.tagName.toLowerCase();
      const type = (el.getAttribute('type') || '').toLowerCase();

      // Skip non-data controls
      if (tag === 'input' && (type === 'submit' || type === 'button' || type === 'reset' || type === 'file')) {
        continue;
      }

      let value;

      if (tag === 'select') {
        value = el.multiple
          ? Array.from(el.selectedOptions).map(o => o.value)
          : el.value;
      } else if (tag === 'textarea') {
        value = el.value;
      } else if (tag === 'input') {
        if (type === 'checkbox') {
          const group = this.form.querySelectorAll(`input[type="checkbox"][name="${CSS.escape(name)}"]`);
          if (group.length > 1) {
            value = Array.from(group)
              .filter(i => i.checked)
              .map(i => (i.value && i.value !== 'on') ? i.value : true);
          } else {
            value = el.checked ? ((el.value && el.value !== 'on') ? el.value : true) : false;
          }
        } else if (type === 'radio') {
          const checked = this.form.querySelector(`input[type="radio"][name="${CSS.escape(name)}"]:checked`);
          if (!checked) continue;
          value = checked.value;
        } else {
          value = el.value;
        }
      }

      if (typeof value === 'string') value = value.trim();

      // Merge repeated names
      if (data[name] === undefined) {
        data[name] = value;
      } else {
        data[name] = Array.isArray(data[name]) ? data[name] : [data[name]];
        data[name].push(value);
      }
    }

    return data;
  }

  // Strips contact[...] wrapper and normalizes to a simple key
  normalizeContactKey(name) {
    // contact[First name] -> First name
    const match = name.match(/^contact\[(.+)\]$/i);
    return (match ? match[1] : name).trim();
  }

  // Best-effort lookup for common fields (supports multiple naming conventions)
  pickFirst(fields, candidates) {
    for (const key of candidates) {
      if (fields[key] !== undefined && fields[key] !== null && String(fields[key]).trim() !== '') {
        return fields[key];
      }
    }
    return undefined;
  }

  buildPayloadFromForm(fields) {
    const emailInput = this.form.querySelector(this.emailSelector);
    const optInCheckbox = this.form.querySelector(this.checkboxSelector);

    // Email
    const email =
      emailInput?.value?.trim() ||
      this.pickFirst(fields, ['contact[email]', 'email', 'contact[Email]']) ||
      '';

    // Name candidates (adjust if your form uses different labels)
    const firstName = this.pickFirst(fields, [
      'contact[first_name]',
      'contact[First name]',
      'contact[First Name]',
      'firstName',
      'first_name'
    ]);

    const lastName = this.pickFirst(fields, [
      'contact[last_name]',
      'contact[Last name]',
      'contact[Last Name]',
      'lastName',
      'last_name'
    ]);

    const phone = this.pickFirst(fields, [
      'contact[phone]',
      'contact[Phone]',
      'phone',
      'contact[Phone number]',
      'contact[Phone Number]'
    ]);

    // acceptsMarketing from your opt-in checkbox
    const acceptsMarketing = Boolean(optInCheckbox?.checked);

    // Build metafields from remaining fields
    const excludedNames = new Set([
      // core customer fields
      'contact[email]', 'email',
      'contact[first_name]', 'contact[First name]', 'contact[First Name]', 'firstName', 'first_name',
      'contact[last_name]', 'contact[Last name]', 'contact[Last Name]', 'lastName', 'last_name',
      'contact[phone]', 'contact[Phone]', 'phone', 'contact[Phone number]', 'contact[Phone Number]',
      // opt-in checkbox itself (since it becomes acceptsMarketing)
      'contact[Newsletter Opt-In]'
    ]);

    const metafields = {};

    for (const [rawName, value] of Object.entries(fields)) {
      if (excludedNames.has(rawName)) continue;

      // Skip empty strings
      if (value === null || value === undefined) continue;
      if (typeof value === 'string' && value.trim() === '') continue;

      // Optional: ignore Shopify hidden inputs if present
      if (rawName === 'form_type' || rawName === 'utf8') continue;

      const key = this.normalizeContactKey(rawName);
      metafields[key] = value;
    }

    return {
      email,
      firstName: firstName ? String(firstName).trim() : undefined,
      lastName: lastName ? String(lastName).trim() : undefined,
      phone: phone ? String(phone).trim() : undefined,
      acceptsMarketing,
      metafields
    };
  }

  async subscribe() {
    const fields = this.collectFormValues();
    const payload = this.buildPayloadFromForm(fields);

    // If you want: only call backend when opt-in is checked, uncomment:
    // if (!payload.acceptsMarketing) return;

    await fetch(this.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  }
}
